import Component from "./Tooltip";
import TooltipText from "./components/TooltipText";

export interface ITooltipExtensions {
    Text: typeof TooltipText;
}

export const Tooltip: typeof Component & ITooltipExtensions = Object.assign(
    Component,
    { Text: TooltipText },
);

export * from "./presets";
export type { TooltipProps } from "./types";
